export enum SettingsLeftNavbarTabs {
  PREFERENCE = 'preferences',
  SYSTEM_SETTINGS = 'system-settings',
  MEDICATION_PROFILE_SETTINGS = 'medication-profile-settings',
  NO_ACCESS = 'no-access',
}

export enum SettingsLeftNavbarMedicationSubTabs {
  MEDICATION_PROFILE_SETTINGS_MED = 'medication-profile-settings-med-catalogue',
  MEDICATION_PROFILE_SETTINGS_ORDER = 'medication-profile-settings-order-sets',
}

export type SettingsLeftNavbarTabsType = SettingsLeftNavbarTabs;
export type SettingsLeftNavbarMedicationSubTabsType =
  SettingsLeftNavbarMedicationSubTabs;

export interface UserState {
  unsavedData: boolean;
}

export interface UserContextType {
  userState: UserState;
  setUserState: (state: Partial<UserState>) => void;
}
